<script>
import Pagination from '@/components/Pagination';
import ErrorComponent from '@/components/ErrorComponent';
import Alert from '@/components/Alert';
import moment from 'moment';
import 'moment/min/locales';
import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';

export default {
  name: 'Employee',
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker,
    VueTimepicker
  },
  data() {
    return {
      date: {
        startDate: '',
        endDate: ''
      },
      period: '',
      isShow: false,
      decimal_separator: '.',
      precision: 0,
      currency: '',
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      employeeList: [],
      currentSorting: '',
      all_receipt: '',
      receipt: {items: []},
      receiptRefund: {items: []},
      customer_email: '',
      sales: '',
      refund: '',
      filterObj: {
        sort_by: '',
        order_by: 'ASC',
        store_id: '',
        employee_id: '',
        search: '',
        receipt_type: 'ALL',
        to_date: '',
        from_date: '',
        to_time: '',
        from_time: '',
        sync_status: '',
      },
      is_syncing_jubelio: false,
      dinning_options: false,
      is_enable_b2b_setting: false
    };
  },

  methods: {
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        'Y-M-D'
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        'Y-M-D'
      );
      this.$api
        .getAPI({
          _action: '/report/receipts/' + this.itemsPerPage + '/' + page,
          _body: this.filterObj,
          _hide_loader: true
        })
        .then(res => {
          this.is_syncing_jubelio = res.is_syncing_jubelio
          if (res.all_receipt) {
            this.all_receipt = res.all_receipt;
          } else {
            this.all_receipt = 0;
          }
          if (res.sales) {
            this.sales = res.sales;
          } else {
            this.sales = 0;
          }
          if (res.refunds) {
            this.refund = res.refunds;
          } else {
            this.refund = 0;
          }

          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_receipt_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = 'ASC';

      var className = 'sorting_asc';
      var classes = e.target.className;
      if (classes.includes('sorting_asc')) {
        className = 'sorting_desc';
      }

      $('.sorting_asc').removeClass('sorting_asc');
      $('.sorting_desc').removeClass('sorting_desc');

      if (className == 'sorting_asc') {
        $(e.target)
          .addClass('sorting_asc')
          .removeClass('sorting_desc');
        orderBy = 'ASC';
      } else if (className == 'sorting_desc') {
        $(e.target)
          .addClass('sorting_desc')
          .removeClass('sorting_asc');
        orderBy = 'DESC';
      }
      this.getList(1, sortBy, orderBy);
    },
    getPeriod() {
      if (this.period == 'Custom Period') {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: '/store/list' })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    getEmployeeList() {
      this.$api
        .getAPI({ _action: '/employee/list' })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
        })
        .catch(e => {});
    },
    setType(type) {
      this.filterObj.receipt_type = type;
      this.getList(1);
    },
    retry() {
      this.getList(1);
    },
    getReceiptDetail(id) {
      this.$api
        .getAPI({ _action: '/sale/detail/' + id })
        .then(res => {
          res.additionDiscount = 0;
          if (res.discounts && res.discounts.length > 0){
            res.additionDiscount = res.discounts[0].amount;
          }
          res.itemDiscount = res.discounted_amount ? res.discounted_amount - res.additionDiscount : res.additionDiscount;
          this.receipt = res;
          if (res.customer_email){
            this.customer_email = res.customer_email
          }
        })
        .catch(e => {});
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        'Y-M-D'
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        'Y-M-D'
      );

      var queryParam = '';
      for (let key in this.filterObj) {
        if (queryParam == '') {
          queryParam += '?' + key + '=' + this.filterObj[key];
        } else {
          queryParam += '&' + key + '=' + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: '/report/export_receipts/' +
          localStorage.getItem('client_id') +
          queryParam
        , _fileName: 'receipts.csv'})
    },

    getExportTransaction() {
        this.$api.getAndDownloadAPI({ _action: '/report/export-transactions'
          , _fileName: 'transactions.csv'})
    },

    reSync(e, sale_id){
      e.stopPropagation();
      this.$api
        .postAPI({
          _action: '/integration/jubelio/resync',
          _body: {'sale_id': sale_id},
        })
        .then(res => {
          this.$notify({
            group: 'foo',
            text: res.message,
            type: 'success'
          });
          this.getList(this.currentPage);
        })
        .catch(e => {
          this.getList(this.currentPage);
        });
    },
    refundBackoffice(e){
      this.$validator.validateAll('refund-form').then(result => {
        if (result) {
          var receiptRefundParams = _.cloneDeep(this.receiptRefund)
          receiptRefundParams['sale_id'] = receiptRefundParams['id']
          var i = receiptRefundParams.items.length
          while (i--) {
            receiptRefundParams.items[i]['sale_item_id'] = receiptRefundParams.items[i]['id']
            receiptRefundParams.items[i]['id'] = receiptRefundParams.items[i]['item_id']
            if (receiptRefundParams.items[i].quantity == 0) {
              receiptRefundParams.items.splice(i, 1);
            }
          }
          if(!!receiptRefundParams.payments && receiptRefundParams.payments.length > 0){
            if(receiptRefundParams.payments.length == 1){
              receiptRefundParams.payments[0].paid_amount = receiptRefundParams.net_amount
              receiptRefundParams.payments[0].amount_due = receiptRefundParams.net_amount
              receiptRefundParams.payments[0].refundable_amount = receiptRefundParams.net_amount
            }
          }
          this.$api
            .postAPI({
              _action: '/sale/refund',
              _body: receiptRefundParams,
            })
            .then(res => {
              this.$notify({
                group: 'foo',
                text: res.message,
                type: 'success'
              });
              $('#RefundModal').modal('hide');
              $('#SalesDetail').modal('hide');
              this.getList(this.currentPage)
              this.$validator.reset();
              this.errors.clear();
            })
            .catch(e => {
            });
        }
      })
    },
    sendReceipt(receipt){
      this.$validator.validateAll('send-receipt-form').then(result => {
        if(result){
            this.$validator.reset();
            this.errors.clear();
            var body = {sale_id: receipt.id, email: this.customer_email}
            this.$api
              .postAPI({
                _action: '/sale/send_receipt',
                _body: body,
              })
              .then(res => {
                this.$notify({
                  group: 'foo',
                  text: res.message,
                  type: 'success'
                });
                this.customer_email = ''
                $('#SendReceiptModal').modal('hide');
              })
              .catch(e => {
                this.customer_email = ''
              });
        }
      })
    },
    setReceiptRefund(receipt){
      this.$validator.reset();
      this.errors.clear();
      this.receiptRefund = _.cloneDeep(receipt)
      this.calculateRefundAmount()
    },
    calculateRefundAmount($event){
      this.receiptRefund.gross_amount = 0
      this.receiptRefund.net_amount = 0
      this.receiptRefund.itemDiscount = 0
      for(var i=0; i < this.receiptRefund.items.length; i++){
        var item = this.receiptRefund.items[i];
        item.gross_amount = item.price * item.quantity
        var discountPerItem = 0;
        if(this.receipt.items[i].discounts && this.receipt.items[i].discounts.length > 0){
            discountPerItem = this.receipt.items[i].discounts[0].amount / this.receipt.items[i].quantity
        }
        item.discountValue = item.quantity * discountPerItem
        this.receiptRefund.itemDiscount += item.discountValue
        this.receiptRefund.gross_amount += item.gross_amount
      }

      // calculate addtional costs
      this.receiptRefund.net_amount = this.receiptRefund.gross_amount - this.receiptRefund.additionDiscount - this.receiptRefund.itemDiscount + this.receiptRefundAdditionCosts
    }
  },

  computed: {
    receiptAdditionCosts() {
      // get additional costs of single receipt
      let totalCost = 0
      if (this.receipt && this.receipt.additionalCosts && this.receipt.additionalCosts.length > 0) {
        totalCost = this.receipt.additionalCosts.reduce((acc, item) => acc + item.cost, 0)
      }

      return totalCost
    },

    receiptRefundAdditionCosts() {
      // get additional costs of single receipt
      let totalCost = 0
      if (this.receiptRefund && this.receiptRefund.additionalCosts && this.receiptRefund.additionalCosts.length > 0) {
        totalCost = this.receipt.additionalCosts.reduce((acc, item) => acc + item.cost, 0)
      }

      return totalCost
    },

    receiptGrossTotal() {
      let receiptGrossTotal = 0
      if (this.receipt) {
        receiptGrossTotal = this.receipt.net_amount + this.receiptAdditionCosts
      }

      return receiptGrossTotal
    }
  },

  mounted() {
    if (localStorage.getItem('currency')) {
      this.currency = localStorage.getItem('currency');
    }

    this.decimal_separator = localStorage.getItem('decimal_separator') || '.';
    this.precision = (localStorage.getItem('decimal_separator') || '') == '' ? 0 : 2;

    this.getStoreList();
    this.getList(1);
    this.getEmployeeList();
    this.dining_options = localStorage.getItem('dining_options', '') == 'true'
    this.is_enable_b2b_setting = localStorage.getItem('is_enable_b2b') == 'true' || false;
  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <!-- <button class="btn btn-light font-16 bg-white border mr-1 rounded-5">
                <i class="fas fa-chevron-left"></i>
              </button>-->
              <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
              <!-- <button class="btn btn-light font-16 bg-white border ml-1 rounded-">
                <i class="fas fa-chevron-right"></i>
              </button>-->
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-2 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select class="form-control" v-model="period" @change="getPeriod()">
                <option value>{{$lang.messages.all_day}}</option>
                <option>{{$lang.messages.custome_period}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.employee_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_employees}}</option>
                <option
                  v-for="employee in employeeList"
                  :key="employee.id"
                  :value="employee.id"
                >{{employee.name}}</option>
              </select>
            </div>
            <div v-if="is_syncing_jubelio"
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.sync_status" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_order}}</option>
                <option key="SYNC_SUCCESS" value="SYNC_SUCCESS">Sync</option>
                <option key="SYNC_ERROR" value="SYNC_ERROR">Sync Error</option>
                <option key="NOT_SYNC" value="NOT_SYNC">Not Sync</option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-right row mb-3">
          <div class="text-right col-md-6">
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 120px;"
              v-if="isShow"
            >
              <vue-timepicker
                v-model="filterObj.to_time"
                @change="getList(1)"
                :placeholder="$lang.messages.start_time"
                format="HH:mm"
              ></vue-timepicker>
            </div>
          </div>
          <div
            class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
            style="width: 180px;"
            v-if="isShow"
          >
            <vue-timepicker
              v-model="filterObj.from_time"
              @change="getList(1)"
              :placeholder="$lang.messages.end_time"
              format="HH:mm"
            ></vue-timepicker>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5 card-report">
              <div class="card-body">
                <div class="report-tab">
                  <nav class="mb-4">
                    <div class="nav nav-tabs receipts-tab-nav" id="nav-tab" role="tablist">
                      <a
                        class="nav-item nav-link active text-left media"
                        id="nav-tab1"
                        data-toggle="tab"
                        href="#tab1"
                        role="tab"
                        aria-controls="tab1"
                        aria-selected="true"
                        @click="setType('ALL')"
                      >
                        <img src="/images/icon_receipts.svg" class="mr-3 mt-2" height="60" />
                        <div class="media-body">
                          <span class="count d-block f-bold text-nowrap" v-if="all_receipt">{{all_receipt}}</span>
                          <span class="count d-block f-bold text-nowrap" v-else>0</span>
                          <span class="font-18 text-nowrap">{{$lang.messages.all_receipts}}</span>
                        </div>
                      </a>
                      <a
                        class="nav-item nav-link text-left media"
                        id="nav-tab2"
                        data-toggle="tab"
                        href="#tab2"
                        role="tab"
                        aria-controls="tab2"
                        aria-selected="false"
                        @click="setType('SALE')"
                      >
                        <img src="/images/icon_reports.svg" class="mr-3 mt-2" height="60" />
                        <div class="media-body">
                          <span class="count d-block f-bold text-nowrap" v-if="sales">{{sales}}</span>
                          <span class="count d-block f-bold text-nowrap" v-else>0</span>
                          <span class="font-18 text-nowrap">{{$lang.messages.sales}}</span>
                        </div>
                      </a>
                      <a
                        class="nav-item nav-link text-left media"
                        id="nav-tab3"
                        data-toggle="tab"
                        href="#tab3"
                        role="tab"
                        aria-controls="tab3"
                        aria-selected="false"
                        @click="setType('REFUND')"
                      >
                        <img src="/images/icon_refund.svg" class="mr-3 mt-2" height="60" />
                        <div class="media-body">
                          <span class="count d-block f-bold text-nowrap" v-if="refund">{{refund}}</span>
                          <span class="count d-block f-bold text-nowrap" v-else>0</span>
                          <span class="font-18 text-nowrap">{{$lang.messages.refunds}}</span>
                        </div>
                      </a>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="tab1"
                      role="tabpanel"
                      aria-labelledby="nav-tab1"
                    >
                      <div class="pink-tape py-1">
                        <div class="row">
                          <div class="col-lg-3 col-5 align-self-center">
                            <a
                              href="javascript:void(0)"
                              class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                              @click="getExport()"
                            >
                              {{$lang.messages.export_receipt}}
                              <i class="mdi mdi-download align-text-top"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="table-responsive">
                      <table class="table table-style-1">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'sale_number')"
                            >{{$lang.messages.receipt}}</th>
                            <th
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'receipt_date')"
                              style="width: 120px"
                            >{{$lang.messages.date}}</th>
                            <th
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'store_name')"
                            >{{$lang.messages.store}}</th>
                            <th
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'customer_name')"
                            >{{$lang.messages.customer}}</th>
                            <th v-if="dining_options" scope="col">{{$lang.messages.product_delivery_option}}</th>
                            <th v-if="dining_options" scope="col" style="min-width: 250px">{{$lang.messages.shipping_address}}</th>
                            <th scope="col">{{$lang.messages.item}}</th>
                            <th scope="col">{{$lang.messages.qty}}</th>
                            <th scope="col">{{$lang.messages.price}} ({{currency}})</th>
                            <th
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'total')"
                            >{{$lang.messages.total}} ({{currency}})</th>
                            <th scope="col">{{$lang.messages.note}}</th>
                            <th
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'employee_name')"
                            >{{$lang.messages.employee}}</th>
                            <th v-if="is_syncing_jubelio"
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'jubelio_sale_id')"
                            >{{$lang.messages.jubelio_sale_id}}</th>
                            <th v-if="is_syncing_jubelio"
                              scope="col"
                              class="sorting"
                              @click="sorting($event, 'jubelio_sale_id')"
                            >{{$lang.messages.sync_status}}</th>
                          </tr>
                        </thead>

                        <template v-for="(item,i) in list">
                          <tbody
                            :key="i"
                            class="clickable-row"
                            @click="getReceiptDetail(item.id)"
                            data-toggle="modal"
                            data-target="#SalesDetail">
                            <tr
                              v-for="(sale_item, index) in item.sale_items"
                              :key="index"
                            >
                              <template v-if="index == 0">
                                <td :rowspan="item.sale_items.length" v-if="!item.refund">
                                  <i class="fas fa-circle text-grey" style="font-size: 20px;"></i>
                                </td>
                                <td :rowspan="item.sale_items.length" v-else>
                                  <i class="fas fa-circle text-danger" style="font-size: 20px;"></i>
                                </td>
                                <td :rowspan="item.sale_items.length">{{item.sale_number}}
                                  <div v-if="item.status == 'REJECTED' "> {{ $lang.messages[item.status.toLowerCase()].toUpperCase()}}</div>
                                </td>
                                <td :rowspan="item.sale_items.length">{{ item.receipt_date | moment("DD-MM-YYYY HH:mm")}}</td>
                                <td :rowspan="item.sale_items.length">{{item.store_name}}</td>
                                <td :rowspan="item.sale_items.length">{{item.customer_name}}</td>
                                <td v-if="dining_options" :rowspan="item.sale_items.length">{{item.dinning_option_name}}</td>
                                <td v-if="dining_options" :rowspan="item.sale_items.length">
                                  <div v-if="!!item.shipping_address && !!item.shipping_address.address_detail">{{item.shipping_address.address_detail}}</div>
                                </td>
                              </template>
                              <td>{{sale_item.item_name}}</td>
                              <td>{{sale_item.item_quantity}}</td>
                              <td>
                                <vue-numeric
                                  v-if="sale_item.item_price"
                                  v-bind:precision="precision"
                                  :separator="decimal_separator"
                                  :value="sale_item.item_price"
                                  :read-only="true"
                                ></vue-numeric>
                              </td>
                              <template v-if="index == 0">
                                <td :rowspan="item.sale_items.length">
                                  <vue-numeric
                                    v-if="item.total"
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :value="item.total + item.additional_costs"
                                    :read-only="true"
                                  ></vue-numeric>
                                  <template v-else>0</template>
                                </td>
                                <td :rowspan="item.sale_items.length">{{item.note}}</td>
                                <td :rowspan="item.sale_items.length">{{item.employee_name}}</td>
                                <td v-if="is_syncing_jubelio" :rowspan="item.sale_items.length">
                                  {{item.jubelio_sale_name}}
                                </td>
                                <td v-if="is_syncing_jubelio" :rowspan="item.sale_items.length">
                                  <div v-if="!item.refund && item.status == 'ACTIVE' ">
                                    <i v-if="$_.filter(item.sale_items, { 'jubelio_sync_status': 'SYNC_ERROR' }).length == 0
                                    && $_.filter(item.sale_items, { 'jubelio_sync_status': 'NOT_SYNC' }).length == 0
                                    && !!item.jubelio_sale_id " class="fas fa-check" style="color: #84c309"></i>
                                    <div v-else-if="!item.is_enable_b2b || !is_enable_b2b_setting">
                                      <div v-if="$_.filter(item.sale_items, { 'jubelio_sync_status': 'SYNC_ERROR' }).length != 0">
                                        <p style="color: red" v-for="item in $_.filter(item.sale_items, { 'jubelio_sync_status': 'SYNC_ERROR' })" :key="item.id">
                                          {{$lang.messages.sku_cannot_be_found.replace("item_name", item.item_name)}}<br>
                                        </p>
                                          <i @click="reSync($event, item.id)" class="fas fa-sync" style="color: #427ced"></i>
                                      </div>
                                      <div v-else-if="$_.filter(item.sale_items, { 'jubelio_sync_status': 'NOT_SYNC' }).length == item.sale_items.length">
                                          <i @click="reSync($event, item.id)" class="fas fa-sync" style="color: #427ced"></i>
                                      </div>
                                      <div v-else>
                                          <p style="color: red">{{$lang.messages.unable_to_sync}}</p>
                                          <i @click="reSync($event, item.id)" class="fas fa-sync" style="color: #427ced"></i>
                                      </div>
                                    </div>

                                  </div>
                                </td>
                              </template>
                            </tr>
                          </tbody>
                        </template>
                      </table>
                      </div>
                      <ErrorComponent @retry="retry()" ref="errorComonent" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right side modal Sales -->
    <div
      class="modal right fade"
      id="SalesDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header d-block text-center">
            <h4
              class="modal-title f-semi-bold font-16"
              id="myModalLabel2"
            >{{ $lang.messages.payment }}</h4>
            <p class="modal-title f-semi-bold font-32" id="myModalLabel2">
              <vue-numeric
                v-if="receipt.net_amount"
                v-bind:precision="precision"
                :separator="decimal_separator"
                :currency="currency"
                :value="receiptGrossTotal"
                :read-only="true"
              ></vue-numeric>
              <template v-else>0</template>
            </p>
          </div>
          <div class="modal-body" style="padding-bottom: 0; border-bottom:1px solid #ddd">
            <div class="card">
              <div class="card-body px-0 pt-0">
                <p class="font-14">
                  <span class="f-semi-bold">{{$lang.messages.cashier}}:</span>
                  {{receipt.employee_name}}
                </p>
                <p class="font-14">
                  <span class="f-semi-bold">{{$lang.messages.pos}}:</span>
                  {{receipt.pos_name}}
                </p>
                <p class="font-14">
                  <span class="f-semi-bold">{{$lang.messages.customer}}:</span>
                  {{receipt.customer_name}}
                </p>
                <p class="font-14" v-if="!!receipt.customer_phone_number">
                  <span class="f-semi-bold">{{$lang.messages.phone_number}}:</span>
                  {{receipt.customer_phone_number}}
                </p>
                <p class="font-14" v-if="!!receipt.dining_option_name">
                  <span class="f-semi-bold">{{$lang.messages.product_delivery_option}}:</span>
                  {{receipt.dining_option_name}}
                </p>
                <p class="font-14" v-if="!!receipt.shipping_address && !!receipt.shipping_address.address_detail">
                  <span class="f-semi-bold">{{$lang.messages.shipping_address}}:</span>
                  {{receipt.shipping_address.address_detail}}
                </p>

                <div class="table-responsive">
                  <table class="table table-style-1 table-borderless mt-0 bg-light">
                    <tbody>
                      <tr v-for="item in receipt.items" :key="item.id">
                        <td class="p-1" v-if="!item.item_variant_combination_id">
                          <i v-if="item.jubelio_sync_status == 'SYNC_ERROR'" class="fas fa-times" style="color: red"></i> {{item.name}}
                          <br />
                          <span class="text-grey font-14">
                            {{item.quantity}} ×
                            <vue-numeric
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.price ? item.price : 0"
                              :read-only="true"
                            ></vue-numeric>
                          </span>
                        </td>
                        <td class="p-1" v-else>
                          <i v-if="item.jubelio_sync_status == 'SYNC_ERROR'" class="fas fa-times" style="color: red"></i>
                          {{item.name}} ({{item.item_variant_combination.value}})
                          <br />
                          <span class="text-grey font-14">
                            {{item.quantity}} ×
                            <vue-numeric
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.price ? item.price : 0"
                              :read-only="true"
                            ></vue-numeric>
                          </span>
                        </td>
                        <td class="p-1 text-right">
                          <vue-numeric
                            v-if="item.gross_amount"
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="item.gross_amount"
                            :read-only="true"
                          ></vue-numeric>
                          <template v-else>0</template>
                          <br />
                          <span class="text-danger font-14">
                            -
                            <vue-numeric
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.discounts && item.discounts.length > 0 ? item.discounts[0].amount : 0"
                              :read-only="true"
                            ></vue-numeric>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- <table class="table table-style-1 table-responsive table-borderless mt-0 bg-light">
                  <tbody>
                    <tr v-for="item in receipt.discounts" :key="item.id">
                      <td class="p-1">{{item.name}}</td>
                      <td class="p-1 text-right">
                        -
                        <vue-numeric
                          v-if="item.amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                  </tbody>
                </table>-->

                <div class="table-responsive">
                  <table class="table table-style-1 table-borderless mt-0 bg-light">
                    <tbody>
                      <tr>
                        <td class="p-1">{{$lang.messages.subtotal}}</td>
                        <td class="p-1 text-right">
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="receipt.gross_amount ? (receipt.gross_amount - receiptAdditionCosts) : 0"
                            :read-only="true"
                          ></vue-numeric>
                        </td>
                      </tr>
                      <tr>
                        <td class="p-1">{{$lang.messages.discount}}</td>
                        <td class="p-1 text-right text-danger">
                          -
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="receipt.itemDiscount"
                            :read-only="true"
                          ></vue-numeric>
                        </td>
                      </tr>
                      <tr>
                        <td class="p-1">{{$lang.messages.additional_discount}}</td>
                        <td class="p-1 text-right text-danger">
                          -
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="receipt.additionDiscount"
                            :read-only="true"
                          ></vue-numeric>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive">
                  <table class="table table-style-1 table-borderless mt-0 bg-light">
                    <tbody>
                      <tr>
                        <td class="p-1 f-bold">{{ $lang.messages.additional_cost }}</td>
                        <td class="p-1 text-right f-bold">
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="receiptAdditionCosts"
                            :read-only="true"
                          ></vue-numeric>
                        </td>
                      </tr>

                      <template v-if="receipt && receipt.additionalCosts && receipt.additionalCosts.length > 0">
                        <tr v-for="cost in receipt.additionalCosts" :key="cost.id">
                          <td class="p-1 text-capitalize">{{ $lang.messages[cost.name] }}</td>
                          <td class="p-1 text-right">
                            <vue-numeric
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="cost.cost"
                              :read-only="true"
                            ></vue-numeric>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive">
                  <table class="table table-style-1 table-borderless mt-0 bg-light">
                    <tbody>
                      <tr>
                        <td class="p-1 f-bold">{{$lang.messages.total}}</td>
                        <td class="p-1 text-right f-bold">
                          <vue-numeric
                            v-if="receipt.net_amount"
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="receiptGrossTotal"
                            :read-only="true"
                          ></vue-numeric>
                          <template v-else>0</template>
                        </td>
                      </tr>
                      <template v-for="(item, index) in receipt.payments">
                        <tr :key="'item1_'  +index">
                          <td class="p-1">{{item.name}}</td>
                          <td class="p-1 text-right">
                            <vue-numeric
                              v-if="item.paid_amount"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.paid_amount"
                              :read-only="true"
                            ></vue-numeric>
                            <template v-else>0</template>
                          </td>
                        </tr>
                        <tr
                          :key="'item2_'  +index"
                          v-if="item.amount_due != item.paid_amount && receipt.payments.length > 0"
                        >
                          <td class="p-1">{{$lang.messages.due_amount}}</td>
                          <td class="p-1 text-right">
                            <vue-numeric
                              v-if="item.amount_due"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.amount_due"
                              :read-only="true"
                            ></vue-numeric>
                            <template v-else>0</template>
                          </td>
                        </tr>
                        <tr v-if="item.payment_type.toUpperCase() === 'CASH'" :key="'item3_'  +index">
                          <td class="p-1">{{$lang.messages.change}}</td>
                          <td class="p-1 text-right">
                            <vue-numeric
                              v-if="item.change"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="item.change"
                              :read-only="true"
                            ></vue-numeric>
                            <template v-else>0</template>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive">
                  <table class="table table-style-1 table-borderless mt-0 bg-light">
                    <tbody>
                      <tr>
                        <td class="p-1 f-bold">{{$lang.messages.note}}</td>
                      </tr>
                      <tr>
                        <td class="p-1">{{receipt.note}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="table-responsive">
                  <table class="table table-style-1 table-borderless mt-0 bg-light">
                    <tbody>
                      <tr>
                        <td class="p-1">{{ receipt.receipt_date_local }}</td>
                        <td class="p-1 text-right">{{receipt.sale_number}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p v-if="$_.filter(receipt.items, { 'jubelio_sync_status': 'SYNC_ERROR' }).length != 0" style="color: red">
                  <i class="fas fa-times" style="color: red"></i>
                  {{$lang.messages.unable_to_synchronize_to_jubelio}}
                </p>

                <div v-if="receipt.refund">
                  <div class="p-1 text-right" style="color: red">{{$lang.messages.refund}} {{ receipt.refund_number }}</div>
                </div>
                <div v-else-if="!!receipt.refund_number">
                  <div class="p-1 text-right" style="color: red">{{$lang.messages.related_to}} {{ receipt.refund_number }}</div>
                </div>
                <div v-if="receipt.storefront_order_number">
                  <div class="p-1 text-right" style="margin-top: 16px; color: red" v-if="receipt.status == 'REJECTED' ">{{$lang.messages.rejected}} {{$lang.messages.from.toLowerCase()}} #OL-{{ receipt.storefront_order_number }}</div>
                  <div class="p-1 text-right" style="margin-top: 16px; color: red" v-else>{{$lang.messages.from}} #OL-{{ receipt.storefront_order_number }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-8">
                  <button
                    data-toggle="modal"
                    data-target="#RefundModal"
                    class="btn btn-primary"
                    @click="setReceiptRefund(receipt)"
                    :disabled="receipt.refund || receipt.status == 'CANCELED' || receipt.status == 'REJECTED' || receipt.items.length == $_.filter(receipt.items, o => o.refund_quantity == o.quantity).length"
                  >{{$lang.messages.refund}}</button>
                </div>
                <div class="col-4 text-right">
                  <button
                    data-toggle="modal"
                    data-target="#SendReceiptModal"
                    class="btn btn-outline-primary"
                  >{{$lang.messages.send_receipt}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="SendReceiptModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="SendReceiptModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5 class="modal-title font-22">{{$lang.messages.send_receipt}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form data-vv-scope="send-receipt-form" v-on:submit.prevent="sendReceipt(receipt)">
            <div class="modal-body form-style">
              <div class="row mb-4">
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.email}}</label>
                  <input
                    name="customer_email"
                    v-model="customer_email"
                    v-validate="'required|email'"
                    maxlength="300"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('send-receipt-form.customer_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <span
                    v-show="errors.has('send-receipt-form.customer_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_email}}</span>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                id="payment-type-save-btn"
                @click="sendReceipt(receipt)"
              >{{$lang.messages.send}}</button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-primary"
                id="payment-type-cancel-btn"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="RefundModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="RefundModal"
      aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content px-lg-4 py-lg-4">
            <div class="modal-header border-0">
              <h5 class="modal-title font-22">{{$lang.messages.refund}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form data-vv-scope="refund-form" v-on:submit.prevent="refundBackoffice()">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header d-block text-center">
                    <h4
                      class="modal-title f-semi-bold font-16"
                    >{{$lang.messages.payment}}</h4>
                    <p class="modal-title f-semi-bold font-32">
                      <vue-numeric
                        v-if="receiptRefund.net_amount"
                        v-bind:precision="precision"
                        :separator="decimal_separator"
                        :currency="currency"
                        :value="receiptGrossTotal"
                        :read-only="true"
                      ></vue-numeric>
                      <template v-else>0</template>
                    </p>
                  </div>
                  <div class="modal-body" style="padding-bottom: 0; border-bottom:1px solid #ddd">
                    <div class="card">
                      <div class="card-body px-0 pt-0">
                        <p class="font-14">
                          <span class="f-semi-bold">{{$lang.messages.cashier}}:</span>
                          {{receiptRefund.employee_name}}
                        </p>
                        <p class="font-14">
                          <span class="f-semi-bold">{{$lang.messages.pos}}:</span>
                          {{receiptRefund.pos_name}}
                        </p>
                        <p class="font-14">
                          <span class="f-semi-bold">{{$lang.messages.customer}}:</span>
                          {{receiptRefund.customer_name}}
                        </p>
                        <div
                          class="border-bottom border-top font-18 py-1"
                          v-if="receiptRefund.dining_option_name"
                        >{{receiptRefund.dining_option_name}}</div>
                        <div class="table-responsive">
                          <table class="table table-style-1 table-borderless mt-0 bg-light">
                            <tbody>
                              <tr v-for="(item, index) in receiptRefund.items" :key="item.id">
                                <td class="p-1" v-if="!item.item_variant_combination_id">
                                  {{item.name}}
                                  <br />
                                  <span class="text-grey font-14">
                                    {{item.quantity}} ×
                                    <vue-numeric
                                      v-bind:precision="precision"
                                      :separator="decimal_separator"
                                      :currency="currency"
                                      :value="item.price ? item.price : 0"
                                      :read-only="true"
                                    ></vue-numeric>
                                  </span>
                                </td>
                                <td class="p-1" v-else>
                                  {{item.name}} ({{item.item_variant_combination.value}})
                                  <br />
                                  <span class="text-grey font-14">
                                    {{item.quantity}} ×
                                    <vue-numeric
                                      v-bind:precision="precision"
                                      :separator="decimal_separator"
                                      :currency="currency"
                                      :value="item.price ? item.price : 0"
                                      :read-only="true"
                                    ></vue-numeric>
                                  </span>
                                </td>
                                <td>
                                  <input v-if="!!receipt && !!receipt.items[index] && !!receipt.items[index].quantity"
                                    :name="'quantity_'  +index"
                                    v-model.number="item.quantity"
                                    v-validate="'required|numeric|min:0|max_value:'+receipt.items[index].quantity"
                                    @change="calculateRefundAmount($event)"
                                    class="form-control"
                                    :class="{'input': true, 'is-danger': errors.has('refund-form.quantity_' + index) }"
                                    type="number"
                                    :max="receipt.items[index].quantity"
                                    :min="0"
                                    v-bind:placeholder="$lang.messages.quantity"
                                  />
                                </td>
                                <td class="p-1 text-right">
                                  <vue-numeric
                                    v-if="item.gross_amount"
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :currency="currency"
                                    :value="item.gross_amount"
                                    :read-only="true"
                                  ></vue-numeric>
                                  <template v-else>0</template>
                                  <br />
                                  <span class="text-danger font-14">
                                    -
                                    <vue-numeric
                                      v-bind:precision="precision"
                                      :separator="decimal_separator"
                                      :currency="currency"
                                      :value="item.discountValue"
                                      :read-only="true"
                                    ></vue-numeric>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-style-1 table-borderless mt-0 bg-light">
                            <tbody>
                              <tr>
                                <td class="p-1">{{$lang.messages.subtotal}}</td>
                                <td class="p-1 text-right">
                                  <vue-numeric
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :currency="currency"
                                    :value="receiptRefund.sub_total ? receiptRefund.sub_total : 0"
                                    :read-only="true"
                                  ></vue-numeric>
                                </td>
                              </tr>
                              <tr>
                                <td class="p-1">{{$lang.messages.discount}}</td>
                                <td class="p-1 text-right text-danger">
                                  -
                                  <vue-numeric
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :currency="currency"
                                    :value="receiptRefund.itemDiscount"
                                    :read-only="true"
                                  ></vue-numeric>
                                </td>
                              </tr>
                              <tr>
                                <td class="p-1">{{$lang.messages.additional_discount}}</td>
                                <td class="p-1 text-right text-danger">
                                  -
                                  <vue-numeric
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :currency="currency"
                                    :value="receiptRefund.additionDiscount"
                                    :read-only="true"
                                  ></vue-numeric>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-style-1 table-borderless mt-0 bg-light">
                            <tbody>
                              <tr>
                                <td class="p-1 f-bold">{{ $lang.messages.additional_cost }}</td>
                                <td class="p-1 text-right f-bold">
                                  <vue-numeric
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :currency="currency"
                                    :value="receiptRefundAdditionCosts"
                                    :read-only="true"
                                  ></vue-numeric>
                                </td>
                              </tr>

                              <template v-if="receipt && receipt.additionalCosts && receipt.additionalCosts.length > 0">
                                <tr v-for="cost in receipt.additionalCosts" :key="cost.id">
                                  <td class="p-1 text-capitalize">{{ $lang.messages[cost.name] }}</td>
                                  <td class="p-1 text-right">
                                    <vue-numeric
                                      v-bind:precision="precision"
                                      :separator="decimal_separator"
                                      :currency="currency"
                                      :value="cost.cost"
                                      :read-only="true"
                                    ></vue-numeric>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-style-1 table-borderless mt-0 bg-light">
                            <tbody>
                              <tr>
                                <td class="p-1 f-bold">{{$lang.messages.total}}</td>
                                <td class="p-1 text-right f-bold">
                                  <vue-numeric
                                    v-if="receiptRefund.net_amount"
                                    v-bind:precision="precision"
                                    :separator="decimal_separator"
                                    :currency="currency"
                                    :value="receiptRefund.net_amount"
                                    :read-only="true"
                                  ></vue-numeric>
                                  <template v-else>0</template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="table-responsive">
                          <table class="table table-style-1 table-borderless mt-0 bg-light">
                            <tbody>
                              <tr>
                                <td class="p-1 f-bold">{{$lang.messages.note}}</td>
                              </tr>
                              <tr>
                                <td class="p-1">{{receiptRefund.note}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <div class="modal-footer border-0 justify-content-center">
              <div class="col-lg-8 left">
                <button
                  type="button"
                  @click="refundBackoffice()"
                  :disabled="receiptRefund.net_amount < 0 || receipt.status == 'CANCELED' || receipt.status == 'REJECTED' "
                  class="btn btn-primary mr-3"
                >{{$lang.messages.refund}}</button>
              </div>
              <div class="col-lg-4 text-right">
                <button
                  type="button"
                  data-dismiss="modal"
                  class="btn btn-outline-primary"
                >{{$lang.messages.cancel_btn_text}}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- modal-content -->
  </div>
</template>

<style scoped>
.table-style-1 tbody td {
  max-width: 150px;
}
</style>